<template>
    <auth-reg-window :show-side-panel="false" :is-auth-mp="true" />
</template>

<script>
import AuthRegWindow from '@/components/AuthReg/AuthRegWindow'

export default {
    components: {
        AuthRegWindow
    },
    mounted() {
        
    }
}
</script>
